import { render, staticRenderFns } from "./StudipTree.vue?vue&type=template&id=c1c467e2&"
import script from "./StudipTree.vue?vue&type=script&lang=js&"
export * from "./StudipTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports